/* eslint-disable no-unused-vars */

class CookieStorage {
    removeItem (key: string): void {
        this.setItem(key, '', new Date(0));
    }

    getItem (key: string): string | null {
        const re = this.getRegExp(key);
        const matches = document.cookie.match(re);
        return matches ? matches[1] : null;
    }

    setItem (key: string, value: string, expDate?: Date): void {
        document.cookie = this.prepareCookie(key, value, expDate);
    }

    clear () {}

    get length () {
        return document.cookie.length;
    }

    key (index: number): string {
        return '';
    }

    private prepareCookie (key: string, value: string, expDate?: Date) {
        const expires = expDate ? `;expires=${expDate.toUTCString()}` : '';
        return `${key}=${value}${expires};path=/`;
    }

    private getRegExp (key: string) {
        return new RegExp(`(?:^|; )${key.replace(/([.$?*|{}()\[\]\\\/+^])/g, '\\$1')}=([^;]*)`);
    }
}

export const cookieStorage = new CookieStorage();
